import LayoutMain from './../../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../../ProgressHUD/index.vue'
import ModalNDA from './ModalNDA/index.vue'
import GoogleMap from './../../../GoogleMap/VueGoogleMap.vue'
import { Api, Toast, Helper } from './../../../../services'

import VueCropper from 'vue-cropper'

export default {
  name: 'ProjectCrowfundingAdd',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    ModalNDA,
    VueCropper,
    GoogleMap,
  },
  data() {
    return {
      project: {
        name: '',
        description: '',
        price: '',
        goal: '',
        country: '',
        size: '',
        user: '', // it's user id
        address: '',
        projectAddress: '',
        businessAddress: '',
        latitude: null,
        longitude: null,
        type: '',
        structure: '',
        competitor: '',
        customer: '',
        industry: '',
        threatCompetitor: false,
        powerSupplier: false,
        powerCustomer: false,
        rivalry: false,
        income: '',
        offerPublic: '',
        type: '',
        businessPlan: {
          definition: '',
          marketPlan1: '',
          operation: '',
          marketPlan2: '',
          pci: '',
          financial: '',
        },
        permit: '',
        installedProject: '',
        draft: false,
      },
      ndaFile: null,
      validationMessage: '',
      displayFirstPage: true,
      types: {
        0: 'Solar',
        1: 'Concentration Solar',
        2: 'Wind',
        3: 'Biogas',
        4: 'Wood Gasification',
        5: 'Gasification of Organics',
        6: 'Waste Gasification',
        7: 'Hydroelectric',
        8: 'Undumotor',
      },
      prjData: [],
      income: 2,
      incomeString: ['Low', 'Medium', 'High'],
      offerPublic: 0,
      offerPublicString: ['Sale of Equity', 'Oreder of Loan'],
      option: {
        img: null,
        size: 1,
        outputType: 'png',
        res: '',
        w: 1200,
        h: 400,
      },
      draft: false,
    }
  },
  methods: {
    setHeightImage() {
      var pic_box = $('.picture-box')
      if (pic_box && pic_box[0]) {
        var h = document.getElementById('content').clientHeight
        pic_box[0].style.height =
          (h > screen.availHeight ? h - 80 : screen.availHeight - 80) + 'px'
      }
    },

    // whenever the document is resized, re-set the 'fullHeight' variable
    handleResize(event) {
      this.setHeightImage()
    },

    eSignNda() {
      this.displayFirstPage = false
    },

    saveDraftNext() {
      this.draft = true;
      this.firstSave();
    },

    saveDraftProject() {
      this.draft = true;
      this.saveProject();
    },

    async firstSave() {
      if (!this.draft) {
        const isValid = await this.$validator.validateAll('firstForm')
        if (!isValid) {
          Toast.validationFieldsError({ toast: this.$toast })
          return
        }
      } else {
        if (this.project.name == "") {
          Toast.validationFieldsError({ toast: this.$toast })
        }
      }

      this.project.permit = this.$refs.selectPermit.value
      this.project.installedProject = this.$refs.installedProject.checked

      this.project.latitude = this.$refs.googleMap.marker.position.lat()
      this.project.longitude = this.$refs.googleMap.marker.position.lng()

      this.project.country = this.$refs.selectCountry.value
      this.project.type = this.$refs.selectType.value

      if (!this.draft) $('#modalNDA').modal('open')
      if (this.draft) {
        this.saveProject()
      }
    },

    async saveProject() {
      try {
        if (!this.draft){
          const isValid = await this.$validator.validateAll('secondForm')
          if (!isValid) {
            Toast.validationFieldsError({ toast: this.$toast })
            return
          }
        }
        else {
          if (this.project.name == "") {
            Toast.validationFieldsError({ toast: this.$toast })
          }
        }
        this.$refs.progress.show()

        this.project.income = this.incomeString[this.income]
        this.project.offerPublic =
          this.offerPublic == 2
            ? this.$refs.offerPublicOther.value
            : this.offerPublicString[this.offerPublic]
        this.project.user = this.$localStorage.get('userid')
        if( this.project.businessPlan) this.project.businessPlan = JSON.stringify(this.project.businessPlan)

        this.project.threatCompetitor = this.$refs.threatCompetitor.checked
        this.project.powerSupplier = this.$refs.powerSupplier.checked
        this.project.powerCustomer = this.$refs.powerCustomer.checked
        this.project.rivalry = this.$refs.rivalry.checked

        var formData = new FormData()
        for (var key in this.project) {
          formData.append(key, this.project[key])
        }

        // if (this!this.draft){
          let image = await this.cropIt()
          formData.append('files0', image)
        // }

        if (this.ndaFile) {
          formData.append('ndaFile0', this.ndaFile)
        }
        formData.append('draft', this.draft)

        var response = await Api.addProject(formData)
        this.$router.push(
           '/project/systemsdetail/crowdfunding/' + response.data.project._id
        )
      } catch (error) {
        var message = 'Something went wrong.'
        if (error.message) {
          message = error.message
        }

        this.validationMessage = message
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: message,
        })
      } finally {
        this.$refs.progress.hide()
      }
    },

    checked(firstEl, secEl) {
      $(secEl).prop('checked', !$(firstEl).is(':checked'))
    },

    onNdaFileChange(event) {
      var files = event.target.files || event.dataTransfer.files
      if (files && files[0]) {
        this.ndaFile = files[0]
      }
    },

    onFileChange(event) {
      var files = event.target.files || event.dataTransfer.files
      if (files && files[0]) {
        var reader = new FileReader()
        let _self = this
        reader.onload = e => {
          var img = new Image()
          img.onload = function() {
            _self.option.w = img.width / (img.height / 400)
            console.log('The width of the image is ' + img.width + 'px.')
          }
          img.src = reader.result
          _self.option.img = e.target.result
        }
        reader.readAsDataURL(files[0])
      }
    },

    cropIt() {
      return new Promise((resolve, reject) => {
        if (this.$refs.cropper.imgs == '') {
          reject({ message: 'Please upload the image' })
          return
        }

        this.$refs.cropper.startCrop()
        this.$refs.cropper.getCropData(image => {
          console.log(image)
          fetch(image)
            .then(res => res.blob())
            .then(blob => {
              const file = new File([blob], 'image.png')
              resolve(file)
            })
            .catch(error => {
              reject(error)
            })
        })
      })
    },
  },
  created() {
    this.countries = require('./../../../../data/country.js')
  },
  mounted() {
    $('.modal').modal()
    $('select').material_select()
    this.setHeightImage()

    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/SystemsDetail/ProjectCrowdfundingAdd/ProjectCrowdfundingAdd.component.js